import { render } from "./FooterFigure.vue?vue&type=template&id=cf997770&scoped=true"
import script from "./FooterFigure.vue?vue&type=script&lang=js"
export * from "./FooterFigure.vue?vue&type=script&lang=js"

import "./FooterFigure.vue?vue&type=style&index=0&id=cf997770&lang=scss&scoped=true"
import "./FooterFigure.vue?vue&type=style&index=1&id=cf997770&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf997770"]])

export default __exports__